const configAggregator = (node) => {
    const productCount = node.getAttribute('data-products-count') ?? 30
    const carouselConfig = {
        enabled: node.getAttribute('data-enabled') !== 'false',
        brandHeading: node.getAttribute('data-brand-heading'),
        brandMode: node.getAttribute('data-brand-mode'),
        upperColor: node.getAttribute('data-upper-color'),
        brandBg: node.getAttribute('data-brand-bg'),
        brandBgMobile: node.getAttribute('data-brand-bg-mobile'),
        brandContent: node.getAttribute('data-brand-content'),
        brandButtonText: node.getAttribute('data-brand-button-text'),
        brandButtonLink: node.getAttribute('data-brand-button-link'),
        brandLogo: node.getAttribute('data-brand-logo'),
        isProductGridEnabledOnDesktop:
            node.getAttribute('data-show-as-grid-desktop') === 'true',
        isProductGridEnabledOnTablet:
            node.getAttribute('data-show-as-grid-tablet') === 'true',
        isProductGridEnabledOnMobile:
            node.getAttribute('data-show-as-grid-mobile') === 'true',
        isLoadMoreEnabled: node.getAttribute('data-enable-load-more') === 'true'
    }

    return {
        skus: node
            .getAttribute('data-sku')
            .split(',')
            .map((sku) => sku.trim())
            .slice(0, productCount),
        ...carouselConfig
    }
}

export default configAggregator
